<template lang="pug">
  .popover.popover-top(:style="positions")
    .arrow(:style="arrowStyle")
    h3.popover-header(v-show="title") {{title}}
    .popover-body {{message}}
      slot

</template>

<script>
const positions = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
}

export default {
  name: 'Popover',
  props: {
    title: String,
    message: String,
    position: String,
    styles: Object,
    arrowStyles: Object
  },
  mounted () {
    this.setPositions()
  },
  data () {
    return {
      positions: {}
    }
  },
  methods: {
    setPositions () {
      let positionValue = '120%'
      if (this.position === 'left' || this.position === 'right') {
        positionValue = '100%'
      }
      this.positions = Object.assign({ [this.getReversePosition(this.position)]: positionValue }, this.styles)
    },
    getReversePosition (position) {
      return positions[position]
    }
  },
  computed: {
    arrowStyle () {
      /* Lógica para agregar la flecha que apunta a los markers dinamicamente */
      let arrowStyle = Object.assign({}, this.arrowStyles) || { 'position': 'bottom' }
      // const position = this.getReversePosition([this.position])
      if (this.position === 'left' || this.position === 'right') {
        arrowStyle.border = '.5rem outset transparent'
      }
      arrowStyle[`border-${this.position}-width`] = '.5rem'
      arrowStyle[`border-${this.position}-style`] = 'solid'
      arrowStyle[`border-${this.position}-color`] = this.arrowStyles.color || '#fdf5e5'
      arrowStyle[this.position] = '100%'
      return arrowStyle
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~@/styles/variables'

  $font-color = #0d2563
  $bg-color = #fdf5e5
  .popover
    display: flex
    justify-content: center
    align-items: center
    width: $f160px
    min-width: 93px
    background-color: $bg-color
    color: $font-color
    border-radius: $f10px
    position: absolute
    font-size: .8rem
    padding: $f10px
    user-select none
    &-header
      font-family: 'Roboto'
      font-weight: bold
      font-size .9rem
    .arrow
      content: ''
      display: block
      position: absolute
      width: 0
      height: 0
      border: $f11px outset transparent
  ul
    padding: 0
    margin: 0
    list-style-position: inside
</style>
